import { connect } from 'react-redux';
import { constant } from './constants';
import React, { useState, useEffect, useRef } from 'react';
import { Tooltip, Drawer, Select } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import StyledTable from "../../../commons/styles/table";
import translation from '../../../commons/translation';
import {
  API_APPCONFIGATTACHMENTS,
  API_MASTERWORKORDERS,
  ATTACHMENTS,
  IPAddress
} from '../../../commons/api';

const { Option } = Select;

const FileBase64 = (props) => {
  const [files, setFiles] = useState(props.Attachments && Array.isArray(props.Attachments) ? props.Attachments : []);
  const [failureCodeAttachment, setFailureCodeAttachment] = useState(props.failureCodeAttachment || false);
  const [viewFilesList, setViewFilesList] = useState(false);
  const [translationCache] = useState(props.translationCache || {});
  const [disableAdd] = useState(props.disableAdd || false);
  const myRef = useRef(null);

  useEffect(() => {
    if (props.Attachments !== files) {
      setFiles(props.Attachments && Array.isArray(props.Attachments) ? props.Attachments : []);
      setFailureCodeAttachment(props.failureCodeAttachment || false);
    }
  }, [props.Attachments, props.failureCodeAttachment]);

  const handleChange4 = (e) => {
    let files = e.target.files;
    const formData = new FormData();
    let filesInfo = [];

    for (const file of files) {
      formData.append('files', file);
      let fileInfo = {
        Name: file.name,
        AttachmentType: file.type,
        Size: Math.round(file.size / 1000) + ' kB'
      };
      filesInfo.push(fileInfo);
      props.fileUpload(filesInfo, 'Attachments', file, props.name);
    }
  };

  // const downloadPDF = (data, filename) => {
  //   const linkSource = `data:application/txt;file,${data}`;
  //   const downloadlink = document.createElement('a');
  //   downloadlink.href = linkSource;
  //   downloadlink.download = filename;
  //   downloadlink.click();
  // };

  // const downloadFile = () => {
  //   const fileObject = files[0];
  //   downloadPDF(fileObject.filePath, fileObject.Name);
  // };

  const handleClick = (e) => {
    if (e === 'Add New Attachments') {
      myRef.current.click();
    } else {
      setViewFilesList(true);
    }
  };

  const columns = [
    {
      title: 'File',
      dataIndex: 'Name',
      key: 'Name',
      align: 'center',
      render: (text, record) => (
        <>
          {failureCodeAttachment === true ? (
            <span>
              <div style={{ marginLeft: '-25px' }}>
                <a
                  href={`${IPAddress.LOCAL}${API_APPCONFIGATTACHMENTS.AppConfigAttachments}/${record.AliasName}`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {text}
                </a>
              </div>
            </span>
          ) : (
            <span>
              {record && record.AliasName ? (
                <Tooltip placement="top" key="view" title="View">
                  <div style={{ marginLeft: '-25px' }}>
                    <a
                      href={`${IPAddress.LOCAL}${ATTACHMENTS.EamAttachments}/${record.AliasName}`}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {text}
                    </a>
                  </div>
                </Tooltip>
              ) : (
                <Tooltip placement="top" key="viewT" title="View will enable after submit">
                  <div style={{ marginLeft: '-25px' }}>{text}</div>
                </Tooltip>
              )}
            </span>
          )}
        </>
      )
    },
    {
      title: 'Action',
      width: '600',
      align: 'center',
      render: (text, record) => (
        <span>
          {record && record.AliasName ? (
            <Tooltip placement="top" key="download" title="Download">
              <div style={{ marginLeft: '-25px' }}>
                <a
                  href={`${IPAddress.LOCAL}${API_MASTERWORKORDERS.DOWNLOADFILE}?Id=${record.Id}`}
                >
                  <DownloadOutlined style={{ color: '#1a91ff' }} />
                </a>
              </div>
            </Tooltip>
          ) : (
            <Tooltip placement="top" key="download" title="Download will enable after submit">
              <div style={{ marginLeft: '-25px' }}>
                <DownloadOutlined />
              </div>
            </Tooltip>
          )}
        </span>
      )
    }
  ];

  return (
    <>
      <Select
        placeholder={translation(translationCache, constant.PleaseSelect)}
        onSelect={(e) => handleClick(e)}
        style={{ width: '100%' }}
      >
        <Option key={'View Attachments'} value={'View Attachments'}>
          {translation(translationCache, constant.ViewAttachments)}
        </Option>
        <Option
          disabled={disableAdd}
          key={'Add New Attachments'}
          value={'Add New Attachments'}
        >
          {translation(translationCache, constant.AddNewAttachments)}
        </Option>
      </Select>
      <input
        type="file"
        ref={myRef}
        onChange={handleChange4}
        style={{ display: 'none' }}
      />
      <Drawer
        title="Uploaded Files"
        open={viewFilesList}
        width={600}
        onOk={() => setViewFilesList(false)}
        onClose={() => setViewFilesList(false)}
      >
        <StyledTable size="small"
          columns={columns}
          dataSource={
            props.Attachments && Array.isArray(props.Attachments) ? [...props.Attachments] : []
          }
        />
      </Drawer>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(FileBase64);